import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {computed} from 'mobx';
import {isDesktop} from 'app/utils';
import {desktopLargeMedia, isDesktopLargeMedia} from 'app/utils/windowFunctions';
import logEvent from 'app/amplitude/log_event';
import {setStreamsTimeout} from 'app/components/streams/stream_functions';
import StreamPopup from 'app/components/streams/stream_popup';
import {streamStore} from 'app/store/global';
import StreamsAside from './streams_aside';

export default inject('streamStore', 'userStore')(observer(class StreamsPlayPage extends Component {
    constructor() {
        super();
        this.closeStreamHandler = this.closeStreamHandler.bind(this);
        this.desktopLargeMedia = desktopLargeMedia();
        this.state = {
            desktopLarge: isDesktopLargeMedia()
        };
    }

    @computed get streams() {
        const {streams, userStreams} = this.props.streamStore;
        return [...streams, ...userStreams];
    }

    componentDidMount() {
        setStreamsTimeout();
        this.desktopLargeMedia.addEventListener('change', this.handleDesktopLargeChange);
    }

    componentWillUnmount() {
        this.desktopLargeMedia.removeEventListener('change', this.handleDesktopLargeChange);
    }

    handleDesktopLargeChange = event => {
        this.setState({desktopLarge: event.matches});
    };

    openStreamHandler = stream => {
        logEvent('STREAM_OPENED');
        streamStore.chooseStream(stream);
    };

    closeStreamHandler() {
        this.openStreamHandler(null);
    }

    render() {
        const {stream, hideQueryParams, opened} = this.props.streamStore;
        const {desktopLarge} = this.state;
        const showCompactStreams = isDesktop() && !desktopLarge && !stream;

        return <Fragment>
            {stream && <div className="popup-stream" style={{display: 'block'}}>
                <StreamPopup
                    hideQueryParams={hideQueryParams}
                    opened={opened}
                    streams={this.streams}
                    stream={stream}
                    closeStreamHandler={this.closeStreamHandler}/>
            </div>}
            {showCompactStreams && <div className="streams-compact">
                <StreamsAside compact/>
            </div>}
            <div id="dividerStream"/>
            {this.props.children}
        </Fragment>;
    }
}));
